export default "__VITE_ASSET__CxU3xVca__"